<script>
    import PasswordSetter from '../../components/PasswordSetter.svelte';
	import Spinner from '../../components/Spinner.svelte';
	import UnathContext from '../../layouts/UnathContext.svelte';
	import { navigate } from 'svelte-routing';
	import queryString from 'query-string';
	import firebase from '../../firebase';

    const code = queryString.parse(window.location.search).code;
	let password = '';
	let isValidPassword;
	let message;
    let promise;

	const doReset = async () => {
		message = null;
		promise = (async () => {
            if (!isValidPassword) throw { message: 'Password is not valid.' };
			await firebase.auth().confirmPasswordReset(code, password)
		})()
			.then(() => navigate('/auth/sign-in'))
			.catch(error => message = { type: 'error', text: error.message });
	}
</script>

<UnathContext title="Reset password" on:enterPressed={doReset}>
	<div class="modal">
		<div class="modal__box modal__box--md">
			<div class="modal__header">
				Reset password
			</div>
			<div class="modal__body layout">
				<div class="layout__column">
					<PasswordSetter bind:password={password} bind:isValid={isValidPassword} />
					{#if message}
						<div class="layout__item {message.type}-message">{message.text}</div>
					{/if}
					<div class="layout__row layout__row--collapsable layout__row--space-between">
						<div class="layout__item">
							<div
								class="form__button form__button--subtle"
								on:click={() => navigate('/auth/sign-in')}>
								Return to sign in
							</div>
						</div>
						<div class="layout__row layout__row--right">
							<div class="layout__item">
								{#await promise}
									<div class="form__button form__button--disabled"><Spinner />Reset password</div>
								{:then result}
									<div class="form__button" on:click={doReset}>Reset password</div>
								{/await}
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</UnathContext>